<div
  class="tab-pane engine__tab-pane fade show active"
  id="holidays"
  role="tabpanel"
  aria-labelledby="holidays-tab"
>
  <form class="search-from" name="holiday">
    <div class="search-form__engine search-form__row justify-content-between">
        <div class="search-form__engine--row">

          <div class="search-form__guests search-form__element p-0">
            <app-engine-control-guests
              (click)="onInputSelection()"
            ></app-engine-control-guests>
          </div>

          <div class="search-form__dest search-form__element pr-0">
            <app-engine-tour-modal-destinations
              [onlyCustomHoliday]="onlyCustomHoliday | async"
              [onlyNetQuotes]="onlyNetQuotes | async"
              [engineTabType]="engineTabType"
              [defaultDestination]="holidaySearchParams?.destinationList[0]"
              (click)="onInputSelection()"
              (selectedDestination)="onSelectedDestination($event)"
            ></app-engine-tour-modal-destinations>
          </div>

          <div class="search-form__calendar search-form__element pr-0">
            <app-engine-tour-control-datepicker
              [onlyCustomHoliday]="onlyCustomHoliday | async"
              [defaultDate]="
                selectedDateString || holidaySearchParams?.date_from
              "
              (click)="onInputSelection()"
              [selectedDestination]="selectedDestination"
              [engineTabType]="engineTabType"
              (selectedDate)="onSelectedDate($event)"
            ></app-engine-tour-control-datepicker>
          </div>

        </div>
      <button [disabled]="!selectedDestination?.value" (click)="searchHoliday()" class="search-form__cta btn btn--sm btn--brand-color-03 btn__uppercase mt-3">
        Cerca <i class="icon-search"></i>
      </button>
    </div>
  </form>
</div>

